import React, { useEffect, useState } from "react";

// Chakra imports
import { Flex } from "@chakra-ui/react";
import { useSelector } from "react-redux";


export function IconBrand() {
  //   Chakra color mode
  const [logoUrl,setLogoUrl] = useState("")
  const logoData = useSelector((state) => state.logoData);

  useEffect(()=>{
    if(logoData && logoData?.downloadUrl){
      const url = logoData?.downloadUrl;
      setLogoUrl(url)
    }
  },[logoData])

  return (
    <Flex h={100} justifyContent="center" direction="column" className="logo-container" paddingLeft={1}>
      <img src={logoUrl ? logoUrl :""} alt="" style={{ width: "50px",height:'50px' }}  />
    </Flex>
  );
}

export default IconBrand;
